<ion-app>
  <app-header></app-header>
  <app-menu></app-menu>
  <app-shard-health-banner *ngIf="currentUser !== null"></app-shard-health-banner>
  <app-timeline-mode-banner *ngIf="currentUser !== null"></app-timeline-mode-banner>
  <ion-content>
    <ion-grid class="no-margin height-100">
      <ion-row class="no-margin height-100">
        <ion-col size-xl="0.55" size-lg="0.85" class="no-margin hidden-md-down" *ngIf="currentUser !== null && showSideMenu && router.url !== '/project-selector' && showMenu">
          <app-sidebar-menu></app-sidebar-menu>
        </ion-col>
        <ion-col>
          <ion-router-outlet id="main-content"></ion-router-outlet>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</ion-app>
